import { render } from "./CustomForm.vue?vue&type=template&id=7547e67f&scoped=true"
import script from "./CustomForm.vue?vue&type=script&lang=js"
export * from "./CustomForm.vue?vue&type=script&lang=js"

import "./CustomForm.vue?vue&type=style&index=0&id=7547e67f&scoped=true&lang=css"
import "./CustomForm.vue?vue&type=style&index=1&id=7547e67f&lang=css"

import exportComponent from "/www/wwwroot/check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7547e67f"]])

export default __exports__